import React from 'react';

// Components
import Accordion from 'components/UiKit/Accordion/Accordion';

// Type
import { searchListByIdsResult } from 'pages/Search/type';

// Interface
interface IResultOverview {
	data: searchListByIdsResult
}

export const SearchByListOfIDs: React.FC<IResultOverview> = (props: IResultOverview) => {
	const { data } = props;

	const inputIds = data?.resultsOverview?.inputIds;
	const notFoundIds = data?.resultsOverview?.notFoundIds;

	const headerAccordion = <p className="search-screen__results-overview-text mt10">{notFoundIds?.length || 0} out
		of {inputIds} unique ids were not
		found.</p>;

	return notFoundIds?.length ? (
		<div className="search-screen__results-overview mt10 full-width">
			<b className="search-screen__results-overview-title">Results Overview</b>
			<Accordion header={headerAccordion}>
				<div className="flex flex-ai-center flex-wrap mt10">
					{notFoundIds?.map((item: string) =>
						<p key={item} className="search-screen__results-overview-text mr10 mt10">
							{item}
						</p>
					)}
				</div>
			</Accordion>
		</div>
	) : <></>;
};

export default SearchByListOfIDs;